import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "margin-top-20px pre-line" }
const _hoisted_4 = { class: "width-60pct" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_CompteurDataTable = _resolveComponent("CompteurDataTable")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t('outils.compteur.step.three.title.ajout.compteur')) + " ", 1),
      _createVNode(_component_ReglePastille, { cle: "outils.etape3Compteurs" })
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('outils.compteur.step.three.subtitle.ajout.compteur')), 1),
    _createVNode(_component_CompteurDataTable, {
      "table-header": _ctx.tableHeader,
      "table-data": _ctx.compteurs,
      count: _ctx.compteurs.length,
      class: "table"
    }, null, 8, ["table-header", "table-data", "count"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_ButtonBlue, {
        onClick: _ctx.addCompteur,
        text: _ctx.$t('outils.compteur.step.three.boutton.ajouter.compteur'),
        class: "blueBtn bouton-ajout",
        disabled: _ctx.ajoutDisabled
      }, null, 8, ["onClick", "text", "disabled"])
    ])
  ]))
}